var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.flightStatusTexts[_vm.status])?_c('div',{class:['status', _vm.flightStatusTexts[_vm.status].class]},[_vm._v("\n  "+_vm._s(_vm.flightStatusTexts[_vm.status].status)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }